import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));

// ✅ Helper: construct headers dynamically
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  // only tenant-admin OR if subTenantId is missing
  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

// ✅ Helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
    const subTenantId = decodedToken?.subTenantId;
    return subTenantId ? `&subTenantId=${subTenantId}` : "";
  } else if (switched && switchedSubtenant) {
    return `&subTenantId=${switchedSubtenant?.id}`;
  }
  return "";
};

// ✅ Helper: build subTenantDTO
const getSubTenantDTO = () => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId) {
    return { id: decodedToken.subTenantId };
  }
  return null;
};

const ColdTraceabilityApi = {
  // Create cold traceability Api
  Createcoldtraceability: (data) => {
    let jsonData = JSON.parse(data);

    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) {
      jsonData.subTenantDTO = subTenantDTO;
    }

    return apiApp
      .post(`/coldTraceability`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },

  // List cold traceability Api
  ListColdTraceaability: (page, limit) => {
    return apiApp
      .get(
        `/coldTraceability/?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },

  // Update Cold Traceability Api
  PutColdTraceabiltyApi: (ColdTraceabiltyID, data) => {
    let jsonData = JSON.parse(data);

    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) {
      jsonData.subTenantDTO = subTenantDTO;
    }

    return apiApp
      .put(`/coldTraceability/${ColdTraceabiltyID}`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },

  // Single Cold Traceability Api
  SingleColdTraceabilty: (TraceID) => {
    return apiApp
      .get(
        `/coldTraceability/${TraceID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },

  // Delete Cold Traceability Api
  DeleteColdTraceability: (TraceID) => {
    return apiApp
      .delete(`/coldTraceability/${TraceID}`, {
        headers: getHeaders(),
      })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },
};

export default ColdTraceabilityApi;
